import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoInternetComponent } from './no-internet/no-internet.component';
import { CommonModalComponent } from './common-modal/common-modal.component';
import { UpdateAppModalComponent } from './update-app-modal/update-app-modal.component';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { FilterPipe } from './pipes/filter.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { NumberOnlyWithDotDirective } from './directives/number-only-with-dot.directive';
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { ClickModifiersPlugin } from './directives/click-modifiers.plugin';
import { ConfirmationModalComponent } from '../click-it/orders/cement/confirmation-modal/confirmation-modal.component';
import { FileDragNDropDirective } from './directives/file-drag-n-drop.directive';
import { TranslateModule } from '@ngx-translate/core';
import { UserPermissionComponent } from './user-permission/user-permission.component';
import { PaymentErrorModelComponent } from '../click-it/create-order/cement/payment-error-model/payment-error-model.component';
import { PaymentModelComponent } from '../click-it/create-order/cement/payment-model/payment-model.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { SuccessModalComponent } from '../click-it/create-order/cement/success-modal/success-modal.component';
import { NewOrderModalComponent } from '../click-it/create-order/cement/new-order-modal/new-order-modal.component';
import { CapitalizeFirstLetterPipe } from './pipes/capitalize-first-letter.pipe';
import { RemoveSpacePipe } from './pipes/remove-space.pipe';
import { DisableCountryDropdownDirective } from './directives/disable-country-dropdown.directive';
import { IconLoaderComponent } from './icon-loader/icon-loader.component';
import { AlphaNumericDirective } from './directives/alpha-numeric.directive';

@NgModule({
  declarations: [
    NoInternetComponent,
    CommonModalComponent,
    FooterComponent,
    LoaderComponent,
    UpdateAppModalComponent,
    SpinnerComponent,
    NumberOnlyDirective,
    AlphaNumericDirective,
    FilterPipe,
    CapitalizeFirstLetterPipe,
    ErrorModalComponent,
    PaymentModelComponent,
    PaymentErrorModelComponent,
    NumberOnlyWithDotDirective,
    ConfirmationModalComponent,
    FileDragNDropDirective,
    UserPermissionComponent,
    SuccessModalComponent,
    NewOrderModalComponent,
    CapitalizeFirstLetterPipe,
    RemoveSpacePipe,
    DisableCountryDropdownDirective,
    IconLoaderComponent,
    AlphaNumericDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxIntlTelInputModule,
  ],
  exports: [
    CommonModule,
    NoInternetComponent,
    CommonModalComponent,
    ErrorModalComponent,
    FooterComponent,
    LoaderComponent,
    UpdateAppModalComponent,
    SpinnerComponent,
    NumberOnlyDirective,
    AlphaNumericDirective,
    FilterPipe,
    CapitalizeFirstLetterPipe,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
    NumberOnlyWithDotDirective,
    ConfirmationModalComponent,
    FileDragNDropDirective,
    PaymentModelComponent,
    PaymentErrorModelComponent,
    UserPermissionComponent,
    SuccessModalComponent,
    NewOrderModalComponent,
    UserPermissionComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxIntlTelInputModule,
    RemoveSpacePipe,
    DisableCountryDropdownDirective,
    IconLoaderComponent
  ],
  providers: [
    {
      provide: EVENT_MANAGER_PLUGINS,
      useClass: ClickModifiersPlugin,
      multi: true,
    },
  ],
})
export class SharedModule {}
